<script lang="ts" setup>
	const wrapperElement = ref<HTMLElement | null>()
</script>

<template>
	<section class="relative">
		<div ref="wrapperElement" class="mx-auto max-w-[700px]">
			<slot />
		</div>

		<div
			class="fixed right-10 top-0 z-[100] hidden w-full max-w-[276px] translate-y-48 rounded-md border border-success-500 bg-success-25 lg:block"
			role="purchase-breakdown"
		>
			<slot name="purchase-breakdown" />
		</div>
	</section>
</template>
